import { apiRequest } from './client';
import type { DocDashboardPayload } from '../lib/docTable';

/**
 * `GET /api/docs/dashboard` (V0.44) — one row per document page for the dashboard's Documents
 * tab, locale-complete, joined with the map payload by `lib/docTable.ts`.
 *
 * The payload TYPES live in `lib/docTable.ts` and are re-exported here: the e2e suite imports
 * the pure library to compute its expectations, and this module reaches Vite-typed config the
 * suite's compiler does not know. Callers in the app may import the types from either place.
 */
export type {
  DashboardChangeKind,
  DashboardDoc,
  DashboardLocaleAi,
  DashboardLocaleCell,
  DashboardNodeAi,
  DocDashboardPayload,
} from '../lib/docTable';

export const fetchDocDashboard = (): Promise<DocDashboardPayload> =>
  apiRequest<DocDashboardPayload>('/api/docs/dashboard');
